(function (global) {
  'use strict';

  var enabledKey = 'plumme-autopilot-on';
  var permissionsKey = 'plumme-autopilot-perms';
  var storedSettings = function () { return global.PlummeBackend?.appState?.settings?.autopilot || null; };
  var backendAvailable = function () { return typeof global.PlummeBackend?.updateState === 'function'; };
  var patchSettings = function (patch) {
    if (backendAvailable()) {
      global.PlummeBackend.updateState(function (state) {
        return { ...state, settings: { ...(state.settings || {}), autopilot: { ...((state.settings || {}).autopilot || {}), ...patch } } };
      }, true);
      return;
    }
    try {
      if ('enabled' in patch) localStorage.setItem(enabledKey, patch.enabled ? '1' : '0');
      if ('agents' in patch) localStorage.setItem(permissionsKey, JSON.stringify(patch.agents));
    } catch (error) {}
  };
  var getEnabled = function () {
    var stored = storedSettings()?.enabled;
    if (typeof stored === 'boolean') return stored;
    try { var value = localStorage.getItem(enabledKey); return value == null ? true : value === '1'; }
    catch (error) { return true; }
  };
  var setEnabled = function (value) {
    patchSettings({ enabled: !!value });
    global.dispatchEvent(new Event('plumme-autopilot-changed'));
  };

  Object.assign(window, {
    AP_LS_KEY: enabledKey,
    AP_PERMS_KEY: permissionsKey,
    apStoredSettings: storedSettings,
    apBackendAvailable: backendAvailable,
    apPatchSettings: patchSettings,
    apGetOn: getEnabled,
    apSetOn: setEnabled,
  });
})(window);
